export const openNewTab = (url: string) => {
    // simulate user interaction for mobile
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document?.body?.appendChild(link);
    link.click();
    document?.body?.removeChild(link);
};

export const addQueryParam = (url: string, paramKey: string, paramValue: string): string => {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    searchParams.set(paramKey, paramValue);
    return `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`;
};
